import { render, staticRenderFns } from "./page-empty.vue?vue&type=template&id=4e78e92a&"
import script from "./page-empty.vue?vue&type=script&lang=js&"
export * from "./page-empty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports